export default "__VITE_ASSET__A6FMH27R__"